"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactTooltip = _interopRequireDefault(require("react-tooltip"));
var _i18next = _interopRequireDefault(require("i18next"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ReportSummaryMessage(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-e2e": "reportSummary",
    className: "report_summary",
    style: {
      borderRadius: "4px",
      display: 'grid',
      gridTemplateColumns: 'auto',
      gridRowGap: '3px',
      padding: "14px 10px 10px",
      color: "#020202"
    }
  }, /*#__PURE__*/_react["default"].createElement("b", {
    style: {
      color: "#000000",
      fontFamily: "Roboto",
      fontSize: "24px",
      fontWeight: "bold",
      letterSpacing: "0.07px",
      lineHeight: "28px"
    }
  }, " ", _i18next["default"].t("lable.reportSummary"), "\xA0", props.gameType === 'spin' && /*#__PURE__*/_react["default"].createElement("span", {
    className: "fa fa-info-circle",
    style: {
      color: "grey"
    },
    "data-tip": true,
    "data-for": "spin-info"
  })), /*#__PURE__*/_react["default"].createElement(_reactTooltip["default"], {
    id: "spin-info",
    type: "warning",
    place: "bottom",
    effect: "solid",
    className: "cust-tooltip"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "cust_tooltip_content",
    style: {
      paddingLeft: "30px",
      paddingRight: "15px"
    }
  }, /*#__PURE__*/_react["default"].createElement("li", null, _i18next["default"].t("lable.designedHelpGame"), /*#__PURE__*/_react["default"].createElement("br", null), _i18next["default"].t("lable.preflopandPostflop")), /*#__PURE__*/_react["default"].createElement("li", null, _i18next["default"].t("lable.sameAggregatedStats"), /*#__PURE__*/_react["default"].createElement("br", null), _i18next["default"].t("lable.approximateGto")), /*#__PURE__*/_react["default"].createElement("li", null, _i18next["default"].t("lable.checkHandMultiple"), /*#__PURE__*/_react["default"].createElement("br", null), _i18next["default"].t("lable.preflopEstimatedGto"), /*#__PURE__*/_react["default"].createElement("br", null), _i18next["default"].t("lable.biggestErrorSuituation")), /*#__PURE__*/_react["default"].createElement("li", null, _i18next["default"].t("lable.Gto16bbAbove"), /*#__PURE__*/_react["default"].createElement("br", null), _i18next["default"].t("lable.btw6bband12bb")), /*#__PURE__*/_react["default"].createElement("li", null, _i18next["default"].t("lable.roughAbstraction"), /*#__PURE__*/_react["default"].createElement("br", null), _i18next["default"].t("lable.bigPreflopScenarios"), /*#__PURE__*/_react["default"].createElement("br", null), _i18next["default"].t("lable.abstractionsShowError"), /*#__PURE__*/_react["default"].createElement("br", null), _i18next["default"].t("lable.GtoShowCorrectplay"), /*#__PURE__*/_react["default"].createElement("br", null), _i18next["default"].t("lable.GtoSaySmallError")), /*#__PURE__*/_react["default"].createElement("li", null, _i18next["default"].t("lable.bigSampleDetection"), /*#__PURE__*/_react["default"].createElement("br", null), _i18next["default"].t("lable.contextApporachesAnalysisOver"), /*#__PURE__*/_react["default"].createElement("br", null), _i18next["default"].t("lable.playersLowerScore"), /*#__PURE__*/_react["default"].createElement("br", null), _i18next["default"].t("lable.betterWinrate")), /*#__PURE__*/_react["default"].createElement("li", null, _i18next["default"].t("lable.lessonContentYear"))))), /*#__PURE__*/_react["default"].createElement("p", {
    style: {
      color: "#000000",
      fontFamily: "Roboto",
      fontSize: "16px",
      letterSpacing: 0
    }
  }, props.summary));
}
var _default = ReportSummaryMessage;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReportCards/ReportSummaryMessage.js
 ** module id = 2398
 ** module chunks = 0
 **/